/** returns list of notifications preferences
@return { Array }
*/
export const getNotificationPreferencesList = state => state.notificationPreferencesList

export const getOptionalNotificationPreferences = state => {
	return state.notificationPreferencesList.filter(obj => obj.optional)
}

export const getNotOptionalNotificationPreferences = state => {
	return state.notificationPreferencesList.filter(obj => !obj.optional)
}
